import { styled } from "@mui/material/styles";

export const BannerRoot = styled("div")({
  padding: "10px 16px",
  background: "linear-gradient(95deg, rgba(1,236,255,0.10) 0%, rgba(150,46,255,0.12) 100%)",
  borderBottom: "1px solid rgba(1,236,255,0.18)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 16,
  flexWrap: "wrap",
});

export const BannerLeft = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 12,
});

export const BannerTrialPill = styled("span")({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  padding: "3px 10px",
  borderRadius: 999,
  background: "linear-gradient(95deg, rgba(1,236,255,0.2), rgba(150,46,255,0.2))",
  border: "1px solid rgba(1,236,255,0.4)",
  fontSize: 11,
  fontWeight: 600,
  color: "#01ECFF",
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
});

export const BannerMessage = styled("span")({
  fontSize: 13,
  color: "#D1C7FF",
  fontFamily: "Poppins, sans-serif",
  lineHeight: 1.4,
});

export const BannerDaysRemaining = styled("span")({
  fontSize: 13,
  fontWeight: 600,
  color: "#A87EFF",
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
});
